module.exports = {
  popup_hints: {
    settings_button: 'Настроить',
    copy_button: 'Копировать',
    delete_button: 'Удалить',
    download_button: 'Скачать',
    recalculate_metric: 'Пересчитать метрики',
    templates_list_count: 'Количество шаблонов в группе',
    settings_template_icon: 'Настроить шаблон ',
    delete_template_icon: 'Удалить шаблон',
    copy_template_icon: 'Копировать шаблон',
    copy_id: 'Копировать ID',
  },
  system: {
    err403:
      'Метрика не может быть удалена, т.к. она используется в составной метрике либо ручной метрике.',
  },
  relation_metrics: 'Связанные метрики',
  before: 'До',
  after: 'После',
  or: 'или',
  cant_create_group: 'Невозможно создать группу без имени',
  add_metric_template: 'Добавить шаблон метрики',
  metric_templates: 'Шаблоны метрик звонков',
  metric_templates_chats: 'Шаблоны метрик чатов',
  group_name: 'Название группы',
  new_group: 'Новая группа',
  recalculate: 'Пересчитать для всех записей',
  recalculate_manual_metric_only: 'Пересчитать только для записей с изменениями в ручной метрике',
  recalculate_gpt_metric_only: 'Пересчитать, включая группы GPT-метрик, для всех записей',
  all: 'Все',
  none_settings: 'Нет настроек',
  first_secs: 'Первые N секунд',
  first_frase: 'Первые N фраз',
  last_secs: 'Последние N секунд',
  last_frase: 'Последние N фраз',
  pause_duration: 'Порог длительности паузы',
  warning: 'Предупреждение',
  metric: 'Метрики',
  add_metric: 'Добавить метрику',
  group_delete_confirm: 'Вы действительно хотите удалить данную группу?',
  metric_delete_confirm:
    'Удаление метрики повлияет на работу данного аналитического проекта и отчётов в нём. Вы действительно хотите удалить данную метрику?',
  table: {
    name: 'НАЗВАНИЕ',
    type: 'ТИП МЕТРИКИ',
    channel: 'КАНАЛ ПОИСКА',
    settings: 'НАСТРОЙКИ МЕТРИКИ',
    actions: 'Действия',
  },
  meta_metrics: 'Мета метрики',
  vad_metrics: 'VAD метрики',
  chat_metrics: 'CHAT метрики',
  speech_metrics: 'SPEECH метрики',
  other_metrics: 'Other',
  help: 'Подсказка',
  add: 'Добавить',
  cancel: 'Отменить',
  add_template: 'В список шаблонов метрик будет добавлена метрика с именем',
  fill_all: 'Заполните все поля',
  metric_group: 'Группа метрик',
  metric_id: 'ID метрики:',
  project_id: 'ID проекта',
  copy_hint: 'Копировать ID',
  one_metric: 'метрика',
  metric_templates_group: 'Группа шаблонов метрик',
  choose: 'Выберите',
  channel_search: 'Канал поиска',
  classifier_channel_search: 'Канал данных для обработки',
  classifier_model: 'Модель классификатора',
  classifier2_model: 'Ai модель классификатора',
  classifier_theme: 'Тема классификатора',
  classifier2_theme: 'Класс классификатора',
  probably: 'Вероятность',
  summ_silent: 'Единица измерения',
  threshold: 'Порог длительности паузы, (сек.)',
  save: 'Сохранить',
  save_as_template: 'Сохранить как шаблон',
  all_words: 'Учитывать все словоформы',
  color: 'Цвет подсветки',
  alias: 'Алиас метаданных',
  input: 'Ввод',
  secs: 'Секунды',
  role: 'Роли',
  metric_create: 'Создание метрики',
  clear_all: 'Стереть все',
  from_template: 'Выбрать из списка шаблонов',
  from_template_add: 'Добавить метрику из шаблона',
  add_new_template: 'Добавить новый шаблон метрики',
  add_new_metric: 'Добавить новую метрику',
  metric_create_new: 'Создать новую метрику',
  metric_name: 'Название метрики',
  metric_description: 'Описание метрики',
  exclude_begin_sec: 'Исключить из анализа первые N секунд',
  exclude_end_sec: 'Исключить из анализа последние N секунд',
  search_begin_sec: 'Искать в первых N секундах',
  search_end_sec: 'Искать в последних N секундах',
  search_begin_sec_c: 'Искать в первых N репликах',
  search_end_sec_c: 'Искать в последних N репликах',
  relations: 'Связанные метрики',
  relations_after: 'Искать после',
  relations_before: 'Искать до',
  exclude_begin_messages: 'Исключить из анализа первые N реплик',
  exclude_end_messages: 'Исключить из анализа последние N реплик',
  summ_value: 'Единица измерения',
  nonfcr:
    'Данная метрика принимает значение, равное "1", если выполняется условие повторения события с заданный промежуток времени',
  meta: 'Перенос значений метаданных в метрики, чтобы эти данные можно было использовать в отчётах.',
  summ_speech_duration:
    'Показывает сколько времени говорил выбранный спикер. Учитывается время чистого разговора без пауз.',
  summ_silent_duration: 'Показывает длительность всех пауз в выбранном канале в течении записи.',
  interruptions:
    'Показывает количество эпизодов перебивания. Перебить - начать говорить, когда говорит кто-то другой. При этом происходит наложение речи, т.е. одновременный разговор двух и более спикеров.',
  pause_exceed:
    'Показывает количество пауз, которые превышают указанную в настройках метрики длительность.',
  avg_pause_duration: 'Показывает среднюю длительность пауз в выбранном канале.',
  max_pause_duration: 'Показывает длительность самой долгой паузы в выбранном канале.',
  find_words:
    'Показывает количество найденных совпадений с заданным набором слов/фраз в заданном канале.',
  max_monolog_duration: 'Показывает длительность самого долгого участка речи выбранного спикера.',
  tags_metric:
    'Позволяет вручную проставить значения для записей. Значения можно указывать в свободной форме или выбирать из заданного списка.',
  speech_rate_duration:
    'Позволяет измерить в каком темпе говорят собеседники. В результатах метрики для записи указывается средняя скорость речи в выбранном канале.',
  calculated:
    'Показывает результат рассчитанный по заданной формуле. Результат может быть как в числовом, так и в текстовом виде. При расчёте используются данные других метрик. Данная метрика рассчитывается только после того, как будут рассчитаны все остальные метрики в рамках данного Аналитического Проекта.',
  success: 'Успешно',
  error: 'Не удалось',
  recalculate_modal:
    'Внимание! Пересчёт метрик производится только при статусе проекта "Активен".' +
    'Будут пересчитаны все метрики по указанным ниже записям, кроме значений “Ручных метрик“, измененных пользователями.' +
    'Данный процесс может занять продолжительное время. До окончания пересчёта метрики проекта будут обнулены',
  group_delete: 'Вы действительно хотите удалить данную группу?',
  template_delete: 'Вы действительно хотите удалить данный шаблон?',
  metric_template: 'Показывает длительность самой долгой паузы между фразами в чате.',
  c_find_words:
    'Показывает количество найденных совпадений с заданным набором слов/фраз в заданном канале.',
  c_first_answer_duration:
    'Показывает время между первым сообщением в чате и следующим за ним сообщением от другого участника.',
  c_avg_pause_duration: 'Показывает средняя длительность пауз между фразами в чате.',
  c_spell_check: 'Показывает количество найденных орфографических ошибок у выбранной роли.',
  c_num_words_message: 'Показывает количество слов в самом длинном сообщении у выбранной роли.',
  c_characters: 'Показывает количество всех символов в чате у выбранной роли.',
  c_pause_exceed:
    'Показывает количество пауз между фразами в чате, которые превышают указанную в настройках метрики длительность.',
  classifier:
    'Автоматическая категоризация записей по заранее заданным признакам с использованием обученных моделей ИИ. Классифицирует отдельные фразы.',
  classifier2:
    'Автоматическая категоризация записей по заранее заданным признакам с использованием обученных моделей ИИ. Классифицирует звонок целиком.',
  manualMetric: {
    number: 'Число',
    text: 'Текст',
    manual_entry: 'Ручной ввод',
    select_from_list: 'Выбор из списка',
    pictogram: 'Пиктограмма',
    value: 'Значение',
    both: 'Оба',
    toast_edit_success_message: 'Метрика отредактирована',
    toast_edit_error_message: 'Не удалось отредактировать метрику',
    toast_create_success_message: 'Метрика добавлена',
    toast_create_error_message: 'Не удалось добавить метрику',
    toast_update_success_message: 'Значение обновлено',
    toast_update_error_message: 'Не удалось обновить значение',
    available_variant_list: 'Список доступных вариантов',
    allow_multiple_selection: 'Разрешить множественный выбор',
    display_type: 'Тип отображения',
    by_default: 'По умолчанию',
    field_required: 'Поле не заполнено',
    bad_format: 'Неверный формат, символы запрещены',
    placeholder: 'Введите значение',
    add_field_to_search: 'Добавить строку в список',
    value_by_default: 'Значение по умолчанию',
    or: 'или',
    value_from_metric: 'Значение из метрики',
    metric_name: 'Название метрики',
    name: 'Название',
    value_type: 'Тип значения',
    input_method: 'Способ ввода',
    description: 'Описание',
    fill_metric_details: 'Опишите метрику',
    save: 'Сохранить',
    cancel: 'Отмена',
  },
  proc: 'Проценты',
  sec: 'Секунды',
  copy: 'Копия',
  abon_id: 'Идентификатор абонента',
  time_period: 'Временной период',
  theme: 'Тематика обращения',
  not_apply: 'Не применяется',
  placeholder: 'Введите значение',
  gpt_help_text:
    'Метрики, которые использует LLM-модели для получения результата на основе заданного промпта. Для оптимизации запросов к LLM-модели GPT-метрики объединяются в группу, что позволяет отправлять в одном запросе сразу несколько метрик на расчет.',
  export_id: 'Внешний ID',
  export_result: 'Экспортировать результаты',
  dnt_display_in_record: 'Не отображать в просмотре записи',
  dictionaries_exclude: 'Словари с исключениями',
  chat: 'Шаблоны метрик чатов',
  voice: 'Шаблоны метрик звонков',
  gpt: 'Шаблоны GPT-метрик',
  create_voice_metric_template: 'Создать шаблон метрики звонков',
  create_chat_metric_template: 'Создать шаблон метрики чатов',
  choose_template_modal_label: 'Создать шаблон',
  no_metric_templates: 'Отсутствуют доступные шаблоны',
  save_from_template: 'Загрузить из шаблона',
  template_group_description: 'Группа шаблонов метрик',
  fill_from_template_warning: 'Значения будут изменены',

  success_create_metric: 'Метрика добавлена',
  success_edit_metric: 'Метрика отредактирована',
  fail_edit_metric: 'Не удалось отредактировать метрику.',
  fail_create_metric: 'Не удалось создать метрику.',
};
